var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column justify-center",attrs:{"fill-height":""}},[_c('v-btn',{attrs:{"to":"/writer","color":"primary"}},[_vm._v("Commencer")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }